// Libraries
import React from 'react';
import { useTranslation } from 'react-i18next';

// MUI
import Grid from '@mui/material/Grid';

// Core
import auth from '../../../../../../core/authorization';
import { ResourceTextApplication } from '../../../../../../core/resources';

// Common
import ASwitch from '../../../../../../common/inputs/ASwitch';

// Interfaces
// Store
// API
// Feature

interface DisplayAllProps {
    checked: boolean;
    handleClick?: (value: boolean) => void;
}

export default function DisplayAll(props: DisplayAllProps) {
    const { t } = useTranslation<ResourceTextApplication[]>(['AnelmaAnimalAnnouncement', 'AnelmaGeneral']);
    const { checked, handleClick } = props;

    return (
        <Grid size={{ xs: 4, sm: 4, md: 4, lg: 4 }} textAlign='right'>
            <ASwitch
                checked={checked}
                onChange={(checked) => handleClick && handleClick(checked)}
                disabled={!auth.canViewAllAnimalAnnouncementsFromListView}
                id={'view-all-animal-announcements-switch'}
                withoutContainer
                label={t('AnelmaAnimalAnnouncement:1040')}
            ></ASwitch>
        </Grid>
    );
};
